import { Progress } from "antd";
import { useGetTaskStatus } from "./hooks/useGetTaskStatus";

type ProgressBarProps = {
  id: string;
  errorMessage: string;
  onSuccess: (id?: string) => void;
  message?: {
    customMsg?: string;
    closable?: boolean;
  };
  onError?: () => void;
  options?: {
    errorMessageClosable?: boolean;
  };
};

export const ProgressBar = ({ id, errorMessage, onSuccess, message, onError, options }: ProgressBarProps) => {
  const { percent } = useGetTaskStatus(id, errorMessage, onSuccess, message, onError, options);

  return <Progress percent={percent} status="active" />;
};
